import { Box, Input, Modal } from "@vaporfi/uikit";

export interface SearchModalProps {
	onDismiss?: () => void;
	onSearch: (value: string) => void;
	placeholder?: string;
}

export const SearchModal = ({
	onDismiss,
	onSearch,
	placeholder = "Search for contract, symbol or name",
}: SearchModalProps) => {
	return (
		<Modal
			title="Search"
			color="black"
			showCloseIcon
			onDismiss={onDismiss}
			body={
				<Box className="w-full p-4">
					<Box className="flex items-center bg-[#262626] rounded-lg px-4 py-3 w-full">
						<Input
							autoFocus
							type="text"
							placeholder={placeholder}
							className="bg-transparent text-sm text-white placeholder-neutral-500 outline-none w-full"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Box>
				</Box>
			}
		/>
	);
};
